// extracted by mini-css-extract-plugin
export var active = "_2v-7";
export var container = "_2v-0";
export var evenWidth = "_2v-4";
export var large = "_2v-5";
export var outlet = "_2v-8";
export var slide = "_2v-2";
export var small = "_2v-6";
export var tab = "_2v-3";
export var tabs = "_2v-1";